"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ol = require("openlayers");
exports.ol = ol;
var layer_list_1 = require("./layer.list");
var gs_geo_1 = require("gs-geo");
var availableScales = ['5000000', '2000000', '1000000', '500000', '250000', '200000', '150000', '100000', '50000', '25000', '10000', '5000', '2000', '1000'];
var targetDatum;
var targetDatumList = [{
        name: "egsa",
        label: "GGRS 87",
        limits: [18, 34, 31, 43],
        lonlat2me: gs_geo_1.egsa.lotlan2egsa_xy,
        me2lonlat: gs_geo_1.egsa.egsa872lonlat
    },
    {
        name: "web",
        label: "Web Mercator",
        lonlat2me: function (x) { var c = ol.proj.transform([x[0], x[1]], 'EPSG:4326', 'EPSG:3857'); return { _x: c[0], _y: c[1] }; },
        me2lonlat: function (x) { var c = ol.proj.transform([x[0], x[1]], 'EPSG:3857', 'EPSG:4326'); return c; },
    },
    targetDatum = {
        name: "mgrs",
        label: "MGRS",
        limits: [18, 34, 31, 43],
        lonlat2me: gs_geo_1.mgrs.lonlat2mgrs_xy,
        me2lonlat: gs_geo_1.mgrs.mgrs_xy2lonlat
    }];
var olMapPrintable = /** @class */ (function () {
    function olMapPrintable(map, printMapDivId, mmPrintSize, printControlsDivId, params) {
        if (params === void 0) { params = {}; }
        var _this = this;
        this.gridColor = 'orange';
        this.vectorLayers = [];
        this.processingSoDoNotReRenderOnMoveEvent = false;
        this.onRefresh = function (v) { console.log(v); };
        this.mapDummy = {};
        this.projection = params.projection || 'egsa';
        this.parentMap = map;
        this.hideGrid = params.hideGrid || false;
        this.doNotRotateGrid = params.doNotRotateGrid || false;
        this.printMapDivId = printMapDivId;
        this.mmGridLabelsHeight = params.mmGridLabelsHeight || 5;
        this.dpi = params.dpi || 200;
        this.progressDivId = params.progressDivId;
        {
            this.mmPrintSizeX = mmPrintSize[0];
            this.mmPrintSizeY = mmPrintSize[1] || mmPrintSize[0];
        }
        this.lockPreRun().then(function () {
            var printScale = (params.startScale && availableScales.indexOf(params.startScale) !== -1) ? parseInt(params.startScale) : 10000;
            _this.seed.setParams(_this.mmPrintSizeX, _this.mmPrintSizeY, printScale);
            _this.seed.getParams();
            _this.seed.getToken();
            targetDatum = targetDatumList.find(function (t) { return t.name === _this.projection; }) || targetDatumList[0];
            var d = document.getElementById(printMapDivId);
            var width = (_this.dpi || 200) * _this.mmPrintSizeX / 25.4;
            console.log(width);
            d.style.width = width + 'px';
            d.style.height = /*d.clientWidth*/ width * _this.mmPrintSizeY / _this.mmPrintSizeX + 'px';
            d = document.getElementById(map.getTarget());
            d.style.height = d.clientWidth * _this.mmPrintSizeY / _this.mmPrintSizeX + 'px';
            // console.log(d.style.width, d.style.height);
            _this.printControlsDivId = printControlsDivId;
            _this.graphScaleDivId = params.graphScaleDivId;
            _this.noGridLabels = params.noGridLabels || false;
            _this.baseLayer = _this.parentMap.getLayers().item(0);
            _this.gridLayer = new ol.layer.Vector({
                source: new ol.source.Vector()
            });
            _this.parentMap.getLayers().forEach(function (l, index) {
                if (index > 0) {
                    _this.vectorLayers.push(l);
                }
                ;
            });
            _this.printMap = new ol.Map({
                target: printMapDivId,
                layers: [
                    _this.baseLayer
                ].concat(_this.vectorLayers, [
                    _this.gridLayer
                ]),
                view: new ol.View({
                    center: _this.parentMap.getView().getCenter(),
                    zoom: 12
                })
            });
            _this.parentMap.addLayer(_this.gridLayer);
            _this.parentMap.updateSize();
            var printMapWidth = _this.printMap.getSize()[0];
            var parentMapWidth = _this.parentMap.getSize()[0];
            _this.seed.setMapWidth(printMapWidth, parentMapWidth);
            _this.mmToPixelRatio = printMapWidth / _this.mmPrintSizeX;
            _this.pixelSizeFactor = printMapWidth / parentMapWidth;
            // console.log(this.pixelSizeFactor);
            _this.vectorLayers.forEach(function (l) {
                var s = l.getStyle();
                if (s.getStroke) {
                    var w = s.getStroke().getWidth();
                    s.getStroke().setWidth(_this.mmToPixel(1.5));
                }
            });
            _this.assignEvents();
            _this.createPrintControls();
            _this.createMapDummy();
        });
    }
    olMapPrintable.prototype.lockPreRun = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        Module.addOnPostRun(function () {
                            _this._seed = Module;
                            _this.seed = {
                                setParams: function (mmPrintSizeX, mmPrintSizeY, printScale) {
                                    Module.ccall('setParams', null, ['number', 'number', 'number'], [mmPrintSizeX, mmPrintSizeY, printScale]);
                                },
                                setMapWidth: function (printMapWidth, parentMapWidth) {
                                    Module.ccall('setMapWidth', null, ['number', 'number'], [printMapWidth, parentMapWidth]);
                                },
                                setPrintScale: function (printScale) {
                                    Module.ccall('setPrintScale', null, ['number'], [printScale]);
                                },
                                getPrintScale: function () {
                                    return Module.ccall('getPrintScale', // name of C function
                                    'number', // return type
                                    [], // argument types
                                    null); // arguments
                                },
                                getParams: function () {
                                    var retarrayptr = Module.ccall('getParams', // name of C function
                                    'number', // return type
                                    ['number'], // argument types
                                    null); // arguments
                                    // Convert the resulting pointer to a JS array
                                    var retarray = read_1d_long_array(retarrayptr, 2);
                                    console.log('getParams', retarray);
                                },
                                getToken: function () {
                                    var token = Module.ccall('getToken', // name of C function
                                    'number', // return type
                                    [], // argument types
                                    null); // arguments
                                    // Convert the resulting pointer to a JS array
                                    // let retarray = read_1d_double_array(retarrayptr, 2);
                                    console.log('token', token);
                                },
                                mmToPixel: function (mm, inverse) {
                                    var retarrayptr = Module.ccall('mmToPixel', // name of C function
                                    'number', // return type
                                    ['number', 'number'], // argument types
                                    [mm, (inverse) ? 1 : 0]); // arguments
                                    // Convert the resulting pointer to a JS array
                                    var retarray = read_1d_double_array(retarrayptr, 1);
                                    return retarray[0];
                                },
                                dx_dy: function () {
                                    var retarrayptr = Module.ccall('dx_dy', // name of C function
                                    'number', // return type
                                    [], // argument types
                                    null); // arguments
                                    // Convert the resulting pointer to a JS array
                                    var retarray = read_1d_double_array(retarrayptr, 2);
                                    return retarray;
                                }
                            };
                            console.log('post run');
                            resolve();
                        });
                    })];
            });
        });
    };
    olMapPrintable.prototype.createMapDummy = function () {
        var _this = this;
        // console.log(2);
        this.mapDummy.addLayer = function (layer) {
            _this.vectorLayers.push(layer);
            _this.parentMap.addLayer(layer);
            _this.printMap.addLayer(layer);
        };
        this.mapDummy.getView = function () {
            return _this.parentMap.getView();
        };
    };
    olMapPrintable.prototype.mmToPixel = function (mm, inverse) {
        if (inverse === void 0) { inverse = false; }
        // console.log('mmToPixel');
        // console.log(this.seed.mmToPixel(mm, inverse));
        if (inverse) {
            // console.log(mm / this.mmToPixelRatio);
            return Math.round(mm / this.mmToPixelRatio);
        }
        // console.log(mm * this.mmToPixelRatio);
        return Math.round(mm * this.mmToPixelRatio);
    };
    olMapPrintable.prototype.mmToDist = function (mm, inverse, egsa) {
        if (inverse === void 0) { inverse = false; }
        if (egsa === void 0) { egsa = false; }
        if (egsa) {
            console.log('TODO');
        }
        return mm * this.seed.getPrintScale() / 1000;
    };
    olMapPrintable.prototype.updateGridLabelHeight = function (mm) {
        this.mmGridLabelsHeight = mm;
        this.refresh();
    };
    olMapPrintable.prototype.registerOnRefresh = function (f) {
        this.onRefresh = f;
    };
    olMapPrintable.prototype.assignEvents = function () {
        var _this = this;
        this.parentMap.on('moveend', function () {
            console.warn('moveend triggered');
            if (!_this.processingSoDoNotReRenderOnMoveEvent) {
                _this.refresh();
            }
            ;
        });
    };
    olMapPrintable.prototype.refresh = function () {
        var _this = this;
        this.buildGraphScale();
        this.reScale(this.parentMap, this.parentMap.getSize()[0]);
        this.printMap.getView().setCenter(this.parentMap.getView().getCenter());
        this.reScale(this.printMap, this.printMap.getSize()[0]);
        this.updateGrid();
        // console.log(this.printScale, this.seed.getPrintScale());
        this.onRefresh({
            scale: this.seed.getPrintScale(),
            geom: this.vectorLayers
                .map(function (l) { return l.getSource()
                .getFeatures()
                .map(function (f) { return _this.featureCoordinates(f); }); })
        });
    };
    olMapPrintable.prototype.featureCoordinates = function (f) {
        var out = [];
        var geom = f.getGeometry();
        var type = geom.getType();
        if (type === "MultiLineString") {
            var coor = geom.getCoordinates();
            coor.forEach(function (ca) {
                ca.forEach(function (c) {
                    var ll = ol.proj.transform([c[0], c[1]], 'EPSG:3857', 'EPSG:4326');
                    var a = targetDatum.lonlat2me(ll);
                    out.push([a._x, a._y] //lonlat2egsa87(ll)
                    );
                });
            });
        }
        // console.log(out);
        return out;
    };
    olMapPrintable.prototype.createPrintControls = function () {
        var _this = this;
        if (this.printControlsDivId) {
            var scaleSelector_1 = document.createElement('select');
            scaleSelector_1.style.display = 'block';
            scaleSelector_1.style.width = '150px';
            availableScales.forEach(function (c) {
                var o = document.createElement('option');
                o.innerHTML = '1 : ' + c;
                o.value = c;
                scaleSelector_1.appendChild(o);
            });
            scaleSelector_1.onchange = function (t) {
                var scale = parseInt(t.target.value);
                // this.printScale = scale;
                _this.seed.setPrintScale(scale);
                _this.refresh();
            };
            var printScale = this.seed.getPrintScale();
            scaleSelector_1.selectedIndex = availableScales.indexOf(printScale.toString());
            var printControl = document.getElementById(this.printControlsDivId);
            printControl.appendChild(scaleSelector_1);
            var datumSelector_1 = document.createElement('select');
            datumSelector_1.style.display = 'block';
            datumSelector_1.style.marginTop = '10px';
            datumSelector_1.style.width = '150px';
            targetDatumList.forEach(function (c) {
                var o = document.createElement('option');
                o.innerHTML = c.label;
                o.value = c.name;
                datumSelector_1.appendChild(o);
            });
            datumSelector_1.onchange = function (t) {
                // console.log(t);
                var d = targetDatumList.find(function (td) { return td.name === t.target.value; });
                if (d) {
                    targetDatum = d;
                }
                _this.refresh();
            };
            // scaleSelector.selectedIndex = availableScales.indexOf(this.printScale.toString());
            printControl.appendChild(datumSelector_1);
            var layerSelector = document.createElement('select');
            layerSelector.style.display = 'block';
            layerSelector.style.marginTop = '10px';
            layerSelector.style.width = '150px';
            var osm = document.createElement('option');
            osm.innerHTML = 'OSM';
            osm.value = 'osm';
            layerSelector.appendChild(osm);
            var ktima = document.createElement('option');
            ktima.innerHTML = 'ktima';
            ktima.value = 'ktima';
            layerSelector.appendChild(ktima);
            var bingAerial = document.createElement('option');
            bingAerial.innerHTML = 'Bing Aerial';
            bingAerial.value = 'bingAerial';
            layerSelector.appendChild(bingAerial);
            // let tn = document.createElement('option'); tn.innerHTML = 'TopoNavigator'; tn.value = 'tn'; layerSelector.appendChild(tn);
            layerSelector.onchange = function (t) {
                var layer = t.target.value;
                var loading_counter = 0;
                var progressDiv = (_this.progressDivId) ? document.getElementById(_this.progressDivId) : undefined;
                try {
                    _this.parentMap.removeLayer(_this.baseLayer);
                }
                catch (err) { }
                ;
                try {
                    _this.printMap.removeLayer(_this.baseLayer);
                }
                catch (err) { }
                ;
                try {
                    _this.parentMap.removeLayer(_this.gridLayer);
                }
                catch (err) { }
                ;
                try {
                    _this.printMap.removeLayer(_this.gridLayer);
                }
                catch (err) { }
                ;
                _this.vectorLayers.forEach(function (l) {
                    try {
                        _this.parentMap.removeLayer(l);
                    }
                    catch (err) { }
                    ;
                    try {
                        _this.printMap.removeLayer(l);
                    }
                    catch (err) { }
                    ;
                });
                if (layer === 'ktima') {
                    _this.baseLayer = layer_list_1.ktimaLayer;
                    _this.parentMap.addLayer(_this.baseLayer);
                    _this.printMap.addLayer(_this.baseLayer);
                }
                if (layer === 'osm') {
                    _this.baseLayer = layer_list_1.osmLayer;
                    _this.parentMap.addLayer(_this.baseLayer);
                    _this.printMap.addLayer(_this.baseLayer);
                }
                if (layer === 'tn') {
                    _this.baseLayer = layer_list_1.tnLayer;
                    _this.parentMap.addLayer(_this.baseLayer);
                    _this.printMap.addLayer(_this.baseLayer);
                }
                if (layer === 'bingAerial') {
                    _this.baseLayer = layer_list_1.bingAerialLayer;
                    _this.parentMap.addLayer(_this.baseLayer);
                    _this.printMap.addLayer(_this.baseLayer);
                }
                _this.vectorLayers.forEach(function (l) {
                    _this.parentMap.addLayer(l);
                    _this.printMap.addLayer(l);
                });
                _this.parentMap.addLayer(_this.gridLayer);
                _this.printMap.addLayer(_this.gridLayer);
                var source = _this.baseLayer.getSource();
                source.on("tileloadstart", function () {
                    loading_counter += 1;
                    if (progressDiv) {
                        progressDiv.innerHTML = "<b> : " + loading_counter.toString() + " </b>";
                    }
                });
                source.on("tileloadend", function () {
                    loading_counter -= 1;
                    if (progressDiv) {
                        progressDiv.innerHTML = "<b> : " + loading_counter.toString() + " </b>";
                    }
                });
                source.on("tileloaderror", function () {
                    loading_counter -= 1;
                    if (progressDiv) {
                        progressDiv.innerHTML = "<b>" + loading_counter.toString() + " load </b>";
                    }
                });
                _this.refresh();
            };
            printControl.appendChild(layerSelector);
            var gridControlsContainer = document.createElement('div');
            gridControlsContainer.style.display = 'block';
            gridControlsContainer.style.marginTop = '10px';
            printControl.appendChild(gridControlsContainer);
            var gridColorSelector_1 = document.createElement('select');
            // gridColorSelector.style.display = 'block';
            // gridColorSelector.style.marginTop = '10px';
            gridColorSelector_1.style.width = '150px';
            ['orange', 'white', 'red', 'black', 'magenta', 'no'].forEach(function (c) {
                var o = document.createElement('option');
                o.innerHTML = c + ' grid';
                o.value = c;
                gridColorSelector_1.appendChild(o);
            });
            gridColorSelector_1.onchange = function (t) {
                var color = t.taret.value;
                _this.gridColor = color;
                _this.refresh();
            };
            gridControlsContainer.appendChild(gridColorSelector_1);
            var gridTextCheckbox = document.createElement('input');
            gridTextCheckbox.checked = !this.noGridLabels;
            gridTextCheckbox.type = "checkbox";
            gridTextCheckbox.id = "ol-map-printable-grid-text-selector";
            gridTextCheckbox.style.marginLeft = '12px';
            gridTextCheckbox.onchange = function (t) {
                var checked = t.target.checked;
                _this.noGridLabels = !checked;
                _this.refresh();
            };
            gridControlsContainer.appendChild(gridTextCheckbox);
            var gridText = document.createElement('label');
            gridText.htmlFor = 'ol-map-printable-grid-text-selector';
            gridText.style.marginLeft = '5px';
            gridText.style.fontFamily = 'Arial';
            gridText.innerHTML = 'grid labels';
            gridControlsContainer.appendChild(gridText);
        }
    };
    olMapPrintable.prototype.reScale = function (map, divSizeX) {
        var _this = this;
        this.processingSoDoNotReRenderOnMoveEvent = true;
        // let dx = scale * this.mmPrintSizeX / 1000;
        // let dy = scale * this.mmPrintSizeY / 1000;
        var _a = this.seed.dx_dy(), dx = _a[0], dy = _a[1];
        // console.log(dx,dy);
        // console.log(this.seed.dx_dy_from_scale(scale));
        var center = map.getView().getCenter();
        // let forEgsa = true;
        var fraction = 1.0;
        var angle = 0.0;
        var ex = map.getView().calculateExtent(map.getSize());
        var _b = [ex[0], (ex[1] + ex[3]) / 2], xl = _b[0], yl = _b[1];
        var _c = [ex[2], (ex[1] + ex[3]) / 2], xr = _c[0], yr = _c[1];
        var p1 = targetDatum.lonlat2me(/*lonlat2egsa87(*/ ol.proj.transform([xl, yl], 'EPSG:3857', 'EPSG:4326'));
        _d = [p1._x, p1._y], xl = _d[0], yl = _d[1];
        var p2 = targetDatum.lonlat2me(/*lonlat2egsa87(*/ ol.proj.transform([xr, yr], 'EPSG:3857', 'EPSG:4326'));
        _e = [p2._x, p2._y], xr = _e[0], yr = _e[1];
        fraction = (ex[2] - ex[0]) / (xr - xl);
        if (!this.doNotRotateGrid) {
            angle = Math.atan((yr - yl) / (xr - xl));
        }
        map.getView().setResolution(fraction * dx / divSizeX);
        map.getView().setRotation(-angle);
        setTimeout(function () { _this.processingSoDoNotReRenderOnMoveEvent = false; }, 1000);
        var _d, _e;
    };
    olMapPrintable.prototype.setPrintScale = function (sc) {
        // this.printScale = sc;
        // console.log('setPrintScale',sc);
        this.seed.setPrintScale(sc);
    };
    olMapPrintable.prototype.setGraphScaleDivId = function (graphScaleDivId) {
        this.graphScaleDivId = graphScaleDivId;
    };
    olMapPrintable.prototype.buildGraphScale = function () {
        // console.log('buildGraphScale');
        if (this.graphScaleDivId) {
            var graphScaleDiv = document.getElementById(this.graphScaleDivId);
            graphScaleDiv.innerHTML = '';
            var printScale = this.seed.getPrintScale();
            var html = "\n                <div style=\"position:absolute;left:0;top:-100%;width:100%;height:50%;border-left:1px solid grey;border-right:1px solid grey;\">\n                    <div style=\"width:50%;display:inline-block;height:100%;\">\n                        <div style=\"width:50%;display:inline-block;height:100%;\">\n                            <div style=\"width:50%;display:inline-block;height:100%;\"><div style=\"font-size:10pt;position:absolute;line-height:50%;top:-250%;left:-3pt;\">0</div></div>\n                            <div style=\"width:50%;display:inline-block;height:100%;float:right;\"><div style=\"height:100%;width:1px;background-color:grey;\"></div></div>\n                        </div>\n                        <div style=\"width:50%;display:inline-block;height:100%;float:right;\"><div style=\"height:100%;width:1px;background-color:grey;\"></div></div>\n                    </div>\n                    <div style=\"width:50%;display:inline-block;height:100%;float:right;\">\n                        <div style=\"height:100%;width:1px;background-color:grey;\"></div>\n                        <div style=\"font-size:10pt;position:absolute;line-height:50%;top:-250%;right:-3pt;width:100%;text-align:right;\">" + printScale * 0.1 + "</div>\n                    </div>\n                    <div style=\"font-size:10pt;position:absolute;line-height:50%;top:-250%;width:100%;text-align:center;\">" + printScale * 0.1 / 2 + "</div>\n                </div>\n\n                <div style=\"width:100%;border:1px solid grey;height:50%;\">\n                    <div style=\"width:50%;display:inline-block;height:100%;\">\n                        <div style=\"width:50%;display:inline-block;height:100%;\">\n                            <div style=\"width:50%;display:inline-block;height:100%;\"></div>\n                            <div style=\"width:50%;display:inline-block;height:100%;background-color:grey;float:right;\"></div>\n                        </div>\n                        <div style=\"width:50%;display:inline-block;height:100%;float:right;\"></div>\n                    </div>\n                    <div style=\"width:50%;display:inline-block;height:100%;background-color:grey;float:right;\"></div>\n                </div>\n\n                <div style=\"width:100%;border:1px solid grey;height:50%;\">\n                    <div style=\"width:50%;display:inline-block;height:100%;\">\n                        <div style=\"width:50%;display:inline-block;height:100%;\">\n                            <div style=\"width:50%;display:inline-block;height:100%;background-color:grey;\"></div>\n                            <div style=\"width:50%;display:inline-block;height:100%;float:right;\"></div>\n                        </div>\n                        <div style=\"width:50%;display:inline-block;height:100%;background-color:grey;float:right;\"></div>\n                    </div>\n                    <div style=\"width:50%;display:inline-block;height:100%;float:right;\"></div>\n                </div>\n                \n            ";
            // console.log('buildGraphScale');
            graphScaleDiv.innerHTML = html;
        }
    };
    olMapPrintable.prototype.updateGrid = function () {
        // console.log('updateGrid');
        var gridStyle = new ol.style.Style({
            stroke: new ol.style.Stroke({
                color: this.gridColor,
                width: 2
            })
        });
        this.gridLayer.getSource().clear();
        // if (!this.hideGrid) {
        var extent = this.printMap.getView().calculateExtent(this.printMap.getSize());
        var _a = ol.proj.transform([extent[0], extent[1]], 'EPSG:3857', 'EPSG:4326'), x1 = _a[0], y1 = _a[1];
        var _b = ol.proj.transform([extent[2], extent[3]], 'EPSG:3857', 'EPSG:4326'), x2 = _b[0], y2 = _b[1];
        // console.log([x1, y1], [x2, y2]);
        if (!targetDatum.limits
            ||
                (x1 > targetDatum.limits[0] && x2 < targetDatum.limits[2] && y1 > targetDatum.limits[1] && y2 < targetDatum.limits[3])) {
            var x1u = targetDatum.lonlat2me(/*lonlat2egsa87(*/ [x1, y2])._x;
            var y1r = targetDatum.lonlat2me(/*lonlat2egsa87(*/ [x2, y1])._y;
            var p_ll = targetDatum.lonlat2me(/*lonlat2egsa87(*/ [x1, y1]);
            ;
            _c = [p_ll._x, p_ll._y], x1 = _c[0], y1 = _c[1];
            var p_ur = targetDatum.lonlat2me(/*lonlat2egsa87(*/ [x2, y2]);
            _d = [p_ur._x, p_ur._y], x2 = _d[0], y2 = _d[1];
            // console.log([x1, y1], [x2, y2]);
            // console.log(x1, x1u);
            var leftX = Math.max(x1, x1u);
            var bottomY = Math.max(y1, y1r);
            var gridCellSize = this.seed.getPrintScale() * 0.1;
            x1 = Math.floor(x1 / gridCellSize) * gridCellSize - gridCellSize;
            y1 = Math.floor(y1 / gridCellSize) * gridCellSize - gridCellSize;
            x2 = Math.ceil(x2 / gridCellSize) * gridCellSize + gridCellSize;
            y2 = Math.ceil(y2 / gridCellSize) * gridCellSize + gridCellSize;
            var xSize = (x2 - x1) / gridCellSize;
            var ySize = (y2 - y1) / gridCellSize;
            var size = Math.max(xSize, ySize);
            var features = [];
            //console.log(1);
            for (var i = 0; i <= size; i++) {
                console.log(this.gridColor);
                if (!(this.hideGrid || this.gridColor === 'no')) {
                    for (var j = 0; j <= size; j++) {
                        // console.log(i, j);
                        var x = x1 + j * gridCellSize;
                        var y = y1 + i * gridCellSize;
                        // console.log([x, y]);
                        //console.log(egsa872lonlat([x, y]));
                        var p1 = targetDatum.me2lonlat(/*egsa872lonlat(*/ [x, y, p_ll, p_ur]);
                        var _e = ol.proj.transform(p1, 'EPSG:4326', 'EPSG:3857'), x0 = _e[0], y0 = _e[1];
                        var xt = x + gridCellSize;
                        var yt = y; // console.log(egsa872lonlat([xt, yt]));
                        var p2 = targetDatum.me2lonlat(/*egsa872lonlat(*/ [xt, yt, p_ll, p_ur]);
                        _f = ol.proj.transform(p2, 'EPSG:4326', 'EPSG:3857'), xt = _f[0], yt = _f[1];
                        var fH = new ol.Feature(new ol.geom.LineString([[x0, y0], [xt, yt]]));
                        fH.setStyle(gridStyle);
                        features.push(fH);
                        xt = x;
                        yt = y + gridCellSize; // console.log(egsa872lonlat([xt, yt]));
                        _g = ol.proj.transform(targetDatum.me2lonlat(/*egsa872lonlat(*/ [xt, yt, p_ll, p_ur]), 'EPSG:4326', 'EPSG:3857'), xt = _g[0], yt = _g[1];
                        var fV = new ol.Feature(new ol.geom.LineString([[x0, y0], [xt, yt]])); // console.log([[x0, y0], [xt, yt]]);
                        fV.setStyle(gridStyle);
                        features.push(fV);
                    }
                }
                if (!this.noGridLabels) {
                    var x = leftX;
                    var y = y1 + i * gridCellSize;
                    var egsaY = y;
                    _h = ol.proj.transform(targetDatum.me2lonlat(/*egsa872lonlat(*/ [x, y, p_ll, p_ur]), 'EPSG:4326', 'EPSG:3857'), x = _h[0], y = _h[1];
                    var fT = new ol.Feature(new ol.geom.Point([x, y]));
                    fT.setStyle(this.textStyle(egsaY.toString()));
                    features.push(fT);
                    x = x1 + i * gridCellSize;
                    y = bottomY; // console.log('-', [x, y], egsa872lonlat([x, y]), lonlat2egsa87(egsa872lonlat([x, y])));
                    var egsaX = x;
                    _j = ol.proj.transform(targetDatum.me2lonlat(/*egsa872lonlat(*/ [x, y, p_ll, p_ur]), 'EPSG:4326', 'EPSG:3857'), x = _j[0], y = _j[1];
                    var fTY = new ol.Feature(new ol.geom.Point([x, y]));
                    fTY.setStyle(this.textStyle(egsaX.toString(), true));
                    features.push(fTY);
                }
            }
            this.gridLayer.getSource().addFeatures(features);
        }
        var _c, _d, _f, _g, _h, _j;
        // }
    };
    olMapPrintable.prototype.textStyle = function (text, vertical) {
        if (vertical === void 0) { vertical = false; }
        var h = Math.round(this.mmGridLabelsHeight * this.mmToPixelRatio);
        var offset = Math.round(this.mmGridLabelsHeight * this.mmToPixelRatio / 2);
        return new ol.style.Style({
            text: new ol.style.Text({
                // font: `normal ${10 * this.pixelSizeFactor}px Arial`,
                font: "normal " + h + "px Arial",
                text: text,
                stroke: new ol.style.Stroke({
                    color: 'white',
                    width: 0.5 * this.pixelSizeFactor
                }),
                textAlign: 'left',
                offsetX: (vertical ? 0 : offset),
                offsetY: (vertical ? -offset : 0),
                rotation: vertical ? 3 * Math.PI / 2 : 0
            })
        });
    };
    return olMapPrintable;
}());
exports.olMapPrintable = olMapPrintable;
function read_1d_double_array(ptr, length) {
    var array = [];
    for (var i = 0; i < length; i++) {
        var value = Module.getValue(ptr + (i * 8), 'double');
        array.push(value);
    }
    return array;
}
function read_1d_long_array(ptr, length) {
    var array = [];
    for (var i = 0; i < length; i++) {
        var value = Module.getValue(ptr + (i * 4), 'i32');
        array.push(value);
    }
    return array;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ol-map-printable/dist/index.js
// module id = 2
// module chunks = 0